import { SkeletonLoader } from '@/shared/ui/skeleton/skeleton';
import { BannersSkeletonBar, ContentRows } from './styles';

const BannersSkeleton = () => (
  <ContentRows>
    <BannersSkeletonBar>
      <SkeletonLoader />
    </BannersSkeletonBar>
  </ContentRows>
);

export { BannersSkeleton };
